import React from 'react';
import { useRefetchOnRefocus } from 'hooks/useRefetchOnRefocus';
import { GetUsersCourseProgressDocument } from '__generated__/graphql';
import { useSuspenseQuery, useApolloClient } from '@apollo/client';

export function useResultsWithProgress(data) {
  const edges = useCoursesWithProgress(data.courseSearch.edges);

  return React.useMemo(() => {
    return {
      ...data.courseSearch,
      edges,
    };
  }, [data, edges]);
}

export function useCoursesWithProgress(courses) {
  const [isPending, startTransition] = React.useTransition();
  const client = useApolloClient();

  const validCourses = React.useMemo(
    () => courses?.filter(course => course),
    [courses],
  );

  const { data } = useSuspenseQuery(GetUsersCourseProgressDocument, {
    fetchPolicy: 'network-only',
  });

  const { courseProgress } = React.useMemo(
    () => data || { courseProgress: [] },
    [data],
  );

  useRefetchOnRefocus(
    () =>
      !isPending &&
      startTransition(() => {
        client.refetchQueries({
          include: [GetUsersCourseProgressDocument],
        });
      }),
  );

  return React.useMemo(() => {
    return validCourses.map(course => {
      const progress = courseProgress.filter(progressedCourse => {
        return progressedCourse.contentfulCourseId === course.contentfulId;
      })[0];
      return { ...course, progress };
    });
  }, [validCourses, courseProgress]);
}
